import { create } from 'zustand'
import {
	LOCAL_STORAGE_ACCESS_TOKEN,
	LOCAL_STORAGE_REFRESH_TOKEN
} from '@/features/auth/constants.ts'
import type { AuthState, HttpLoginResponse } from '@/features/auth/types.ts'

interface AuthStoreActions {
	reset: () => void
	setAuthData: (data: HttpLoginResponse) => void
}

export const useAuthStore = create<Partial<AuthState> & AuthStoreActions>()(
	(set) => ({
		user: null,
		accessToken:
			localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN) || undefined,
		refreshToken:
			localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN) || undefined,
		reset: () => {
			localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN)
			localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN)
			set({ user: null, accessToken: undefined, refreshToken: undefined })
		},
		setAuthData: (data) => {
			localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, data.access_token)
			localStorage.setItem(
				LOCAL_STORAGE_REFRESH_TOKEN,
				data.refresh_token
			)
			set({
				user: data.user,
				accessToken: data.access_token,
				refreshToken: data.refresh_token
			})
		}
	})
)
